import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="karten-miniatur"
export default class extends Controller {
	static targets = ["miniatur", "referenzKarte"]

  	connect() {}

	// Wenn auf der rechten Seite die Referenz connected wird, wird die passende Miniatur ausgewählt
	referenzKarteTargetConnected(element) {
		const miniatur = this.element.querySelector(`#miniatur-${element.id}`)
		this.selectMiniatur(miniatur)
	}

	selectMiniatur(element) {
		this.miniaturTargets.forEach(miniatur => {
		miniatur.classList.remove("!ring-highlight")
		});
		element.classList.add("!ring-highlight")
	}

	confirmAndDestroyUnterkarte(event) {
		// 1) Confirmation
		if (!window.confirm(event.currentTarget.dataset.confirmation)) {
			event.preventDefault()
			return 
		}

		// 2) Entscheiden, ob und welcher Edit-Container geleert werden muss
		let unterkarteId
  		let editContainer

		if (event.currentTarget.dataset.unterkarteId) {
			unterkarteId = event.currentTarget.dataset.unterkarteId
			editContainer = document.getElementById("edit_karte_container")
		} else {
			unterkarteId = event.currentTarget.dataset.vorlagenunterkarteId
			editContainer = document.getElementById("edit_vorlagenkarte_container")
		}

		// 3) Container ggf. leeren
		if (editContainer && unterkarteId) {
			const selector = `#${CSS.escape(String(unterkarteId))}`
			if (editContainer.querySelector(selector)) {
				editContainer.innerHTML = ""
			}
		}
  	}
}
